module.exports = __webpack_public_path__ + "img/gb6177.prt.e46cd658.jpg";